import { useSolutionGroups } from '../../redux';

const SolutionUserGroup = ({ value = [] }) => {
  const [groupData, dataLoading] = useSolutionGroups();
  console.log(value, 'vas');
  const groupNames = value
    ?.map((id) => groupData.find((g) => g.id === id)?.name)
    .filter(Boolean)
    .join(', ');

  return <span>{groupNames || '–'}</span>;
};

export default SolutionUserGroup;
